import * as stylex from '@stylexjs/stylex';
import { Link } from 'react-router';
import { MdCalendarToday, MdPlace, MdChevronRight } from 'react-icons/md';
import { formatDateTime } from '~utils';
import { styles } from './styles';
import type { PublicSpot } from '~pages/Group/query';
export function Logistics({
  scheduledAt,
  spot
}: {
  scheduledAt: string;
  spot: PublicSpot | null;
}) {
  return <section {...stylex.props(styles.card)}>
      <div {...stylex.props(styles.row)}>
        <MdCalendarToday size={20} {...stylex.props(styles.iconWhen)} />
        <div {...stylex.props(styles.col)}>
          <span {...stylex.props(styles.label)}>When</span>
          <span {...stylex.props(styles.value)}>{formatDateTime(scheduledAt)}</span>
        </div>
      </div>

      {spot && <>
          <div {...stylex.props(styles.divider)} />
          <Link {...stylex.props(styles.row, styles.whereButton)} to={`/spot/${spot.id}`}>
            <MdPlace size={20} {...stylex.props(styles.iconWhere)} />
            <div {...stylex.props(styles.col)}>
              <span {...stylex.props(styles.label)}>Where</span>
              <span {...stylex.props(styles.value)}>{spot.name ?? 'Location'}</span>
              {spot.address && <span {...stylex.props(styles.subtitle)}>{spot.address}</span>}
            </div>
            <MdChevronRight size={20} {...stylex.props(styles.chevron)} />
          </Link>
        </>}
    </section>;
}